import { render, staticRenderFns } from "./TabViewLoader.vue?vue&type=template&id=1dfebfa4&scoped=true&"
import script from "./TabViewLoader.vue?vue&type=script&lang=js&"
export * from "./TabViewLoader.vue?vue&type=script&lang=js&"
import style0 from "./TabViewLoader.vue?vue&type=style&index=0&id=1dfebfa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfebfa4",
  null
  
)

export default component.exports